module.exports = "<form class=\"search\"\n    [formGroup]=\"searchForm\"\n    (ngSubmit)=\"seek(searchForm.controls['input'].value)\">\n    <input class=\"search__field\"\n        type=\"text\"\n        placeholder=\"Искать...\"\n        [formControl]=\"searchForm.controls['input']\">\n    <button  class=\"search__btn\"\n        type=\"submit\">\n    </button>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/mailbox/menu/search/search.component.html
// module id = 621
// module chunks = 1